
import { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Loader from '../Layout/Loader';
import {  BindGrid, exportToExcel, setTitle, setFocus } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";

const CustomerGroupMaster = ({ open,setOpen }) => {

    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [MenuText, setMenuText] = useState("Customer Group Master");

    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })
    const [SaveData, setSaveData] = useState({
        CustomerGroupID: "0",
        CustomerGroupCode: "",
        CustomerGroupName: "",
        Active: true
    });

    const handleClear = async () => {
        setSaveData({
            CustomerGroupID: "0",
            CustomerGroupCode: "",
            CustomerGroupName: "",
            Active: true
        });

        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setFocus('txtCustomerGroupCode');
        setIsUpdate(!isUpdate)
    }

    useEffect(() => {
        setTitle('CustomerGroupMaster', setOpen);
        setFocus('txtCustomerGroupCode');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);

    useEffect(() => {
        getCustomerGroupData();
    }, [filterData.PageIndex, isUpdate]);

    const handleSubmit =  () => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);

        let data = {
            ...SaveData, Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Master/InsertUpdateCustomerGroupMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus)
                handleClear();
                getCustomerGroupData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            } else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
            setIsLoading(false)
        })
    }
    const getCustomerGroupData = (Type = 'S') => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Master/ShowExCustomerGroupData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                const gridDataStr = res.gridData;
                const cleanedGridDataStr = gridDataStr.trim().replace(/\r\n/g, '');
                const gridDataJson = JSON.parse(cleanedGridDataStr);
                if (Type === 'S') {
                    setTableData({
                        ...tableData,
                        gridData: gridDataJson,
                        totalRecord: res.totalRecord
                    });
                }
                else {
                    exportToExcel(gridDataJson, 'CustomerGroupMaster');
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.totalRecord <= 0) {
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]

                    })
            }
            else if (res.status === 'ERROR' || res.message !=="") {
                setIsLoading(false)
                AlertBox(res.status, res.message, res.focus)
                setFocus(res.focus);
            }
            setIsLoading(false)
        })
    }
    const handleEditData =  (ID) => {
        const loginCodeString = String(LoginUserCode);
        setIsLoading(true)
        let data = {
            Token, LoginUserCode: loginCodeString, CustomerGroupID: ID
        }
        post(`${API_SERVER}/api/Master/EditCustomerGroupData`, { ...data }, (res) => {
            if (res.status === 'ERROR' || res.status === 'EXPIRED' || res.message !== "") {
                setIsLoading(false)
                AlertBox(res.status, res.message,)
            }
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message,)
                setIsLoading(false);
                const editRecordStr = res.editRecord;
                const cleanededitRecordStr = editRecordStr.trim().replace(/\r\n/g, '');
                const editRecordJson = JSON.parse(cleanededitRecordStr);
                setSaveData({
                    CustomerGroupID: ID,
                    CustomerGroupCode: editRecordJson[0]['Customer Group Code'],
                    CustomerGroupName: editRecordJson[0]['Customer Group Name'],
                    Active: (editRecordJson[0]['Active'] === 'YES' ? true : false)
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.status === 'ERROR' || res.message !== "") {
                setIsLoading(false)
                AlertBox(res.status, res.message, res.focus)
                setFocus(res.focus);
            }
            setIsLoading(false);
        })
    }

    const handleDeleteData = (ID) => {
        const loginCodeString = String(LoginUserCode);
        setIsLoading(true)
        let data = {
            Token, LoginUserCode: loginCodeString, CustomerGroupID: ID
        }
        post(`${API_SERVER}/api/Master/DeleteCustomerGroupData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus)
                getCustomerGroupData();
                setIsLoading(false)
               
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            setIsLoading(false)
        })
    }
    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getCustomerGroupData();
    }
    const handleDownloadExcel = async () => {
        getCustomerGroupData('E');
    }
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-Customers-end">
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Customer Group Code<span className="Required">*</span></label>
                                            <input
                                                disabled={SaveData.CustomerGroupID !== "0" ? true : false}
                                                
                                                type="text"
                                                id="txtCustomerGroupCode"
                                                maxLength="10"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtCustomerGroupName") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Customer Group Code'
                                                value={SaveData.CustomerGroupCode}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, CustomerGroupCode: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Customer Group<span className="Required">*</span></label>
                                            <input
                                                type="text"
                                                id="txtCustomerGroupName"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("activeCheckbox") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Customer Group'
                                                value={SaveData.CustomerGroupName}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, CustomerGroupName: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-4 col-sm-6" style={{ marginTop:"24px" }}>
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="activeCheckbox"
                                                name='Active'
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("btnSave") };
                                                }}
                                                checked={SaveData.Active}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Active: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {SaveData.CustomerGroupID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id="btnSave" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindGrid tableData={tableData} setFilterData={setFilterData} filterData={filterData} searchHandle={searchHandle}  handleEditData={handleEditData} handleDeleteData={handleDeleteData} FormName='CustomerGroupMaster' />
            
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
          
        </main>
    )
}
export default CustomerGroupMaster